"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createModelController = exports.createMeshController = exports.prepareAnimationClips = void 0;
var THREE = __importStar(require("three"));
var R = __importStar(require("ramda"));
/**
 * Calculates frame index by animation time, fps and frames number
 */
var getCurrentFrame = function (time, fps, numFrames) {
    return Math.floor((time % (numFrames / fps)) / (1 / fps));
};
/**
 * Returns the mesh's animation clips
 */
var prepareAnimationClips = function (meshData, modelData) {
    return meshData.geometryBuffers.map(function (sequenceBuffers, i) {
        // Sequence level
        var sequence = modelData.sequences[i];
        var isNoLoop = false;
        var frameBuffers = sequenceBuffers.map(function (bufferAttribute, i) { return ({
            name: i.toString(),
            vertices: bufferAttribute.array
        }); });
        return THREE.AnimationClip.CreateFromMorphTargetSequence(sequence.label, frameBuffers, // FIXME
        sequence.fps, isNoLoop);
    });
};
exports.prepareAnimationClips = prepareAnimationClips;
/**
 * Creates mesh controller
 */
var createMeshController = function (mesh, meshRenderData, modelData, isDefaultVisible) {
    if (isDefaultVisible === void 0) { isDefaultVisible = false; }
    // Set default visibility of the mesh
    mesh.visible = isDefaultVisible;
    var activeAction;
    var previousAction;
    var framesSum = modelData.sequences.reduce(function (acc, item) { return acc + item.numFrames; }, 0);
    mesh.morphTargetInfluences = Array(framesSum).fill(0);
    var animationClips = (0, exports.prepareAnimationClips)(meshRenderData, modelData);
    var mixer = new THREE.AnimationMixer(mesh);
    var actions = animationClips.map(function (actionClip) { return mixer.clipAction(actionClip, mesh); });
    var meshModelController = {
        /** Return pause state of the mesh */
        get isPaused() {
            if (activeAction) {
                return activeAction.paused;
            }
            return false;
        },
        /**
         * Sets playback rate (animation speed)
         * @param rate
         */
        setPlaybackRate: function (rate) {
            mixer.timeScale = rate !== 0 ? 1 / rate : 0;
        },
        /**
         * Sets visibility of the mesh
         */
        setVisibility: function (isVisible) {
            mesh.visible = isVisible;
        },
        /**
         * Updates delta tile
         */
        update: function (deltaTime) { return mixer.update(deltaTime); },
        /**
         * Sets animation to play
         */
        setAnimation: function (sequenceIndex) {
            var wasPaused = activeAction ? activeAction.paused : false;
            previousAction = activeAction;
            activeAction = actions[sequenceIndex];
            if (previousAction) {
                previousAction.stop();
            }
            // Update mesh morph targets
            var geometry = mesh.geometry;
            if (geometry instanceof THREE.BufferGeometry) {
                // mesh.updateMorphTargets()
                geometry.morphAttributes.position = meshRenderData.geometryBuffers[sequenceIndex];
            }
            activeAction.reset().play();
            activeAction.paused = wasPaused;
        },
        /**
         * Set pause state of the running animation
         */
        setPause: function (isPaused) {
            if (activeAction) {
                activeAction.paused = isPaused;
            }
        },
        /**
         * Jump to specific time of the running animation
         */
        setTime: function (time) {
            if (activeAction) {
                activeAction.time = time;
            }
        },
        /**
         * Returns current time of the running animation
         */
        getCurrentTime: function () { return (activeAction ? activeAction.time : 0); }
    };
    return meshModelController;
};
exports.createMeshController = createMeshController;
/**
 * Creates model controller.
 * @todo refactor this shit
 */
var createModelController = function (meshes, meshesRenderData, modelData, initialSequence) {
    if (initialSequence === void 0) { initialSequence = 0; }
    var playbackRate = 1;
    var isAnimationPaused = false;
    // Active sequence
    var activeSequenceIndex = initialSequence;
    // List of showed sub models indices
    var showedSubModels = modelData.bodyParts.map(function () { return 0; });
    // Path: [bodyPartIndex][subModelIndex][meshIndex][sequenceIndex]
    var meshControllers = meshes.map(function (bodyPart, bodyPartIndex) {
        return bodyPart.map(function (subModel, subModelIndex) {
            return subModel.map(function (mesh, meshIndex) {
                return (0, exports.createMeshController)(mesh, meshesRenderData[bodyPartIndex][subModelIndex][meshIndex], modelData, subModelIndex === 0);
            });
        });
    });
    // Setting default animation
    meshControllers.forEach(function (bodyPart) {
        return bodyPart.forEach(function (subModel) { return subModel.forEach(function (controller) { return controller.setAnimation(activeSequenceIndex); }); });
    });
    var getAnimationTime = function () {
        // @ts-ignore
        return R.converge(R.divide, [R.sum, R.length])(meshControllers.reduce(function (acc, bodyPart) {
            return acc.concat(bodyPart.reduce(function (acc, subModel) { return acc.concat(subModel.map(function (controller) { return controller.getCurrentTime(); })); }, []));
        }, []));
    };
    var areSubModelsPaused = function () {
        return meshControllers.reduce(function (acc, bodyPart) {
            return acc &&
                bodyPart.reduce(function (acc, subModel) { return acc && subModel.reduce(function (acc, controller) { return acc && controller.isPaused; }, true); }, true);
        }, true);
    };
    /** Returns current state of the model */
    var getCurrentState = function () { return ({
        isPaused: areSubModelsPaused(),
        activeAnimationIndex: activeSequenceIndex,
        showedSubModels: showedSubModels,
        frame: getCurrentFrame(getAnimationTime(), modelData.sequences[activeSequenceIndex].fps, modelData.sequences[activeSequenceIndex].numFrames),
        playbackRate: playbackRate
    }); };
    var modelController = {
        /**
         * Updates delta til=me
         * @param deltaTime
         */
        update: function (deltaTime) {
            return meshControllers.forEach(function (bodyPart) {
                return bodyPart.forEach(function (subModel) {
                    return subModel.forEach(function (controller) {
                        controller.update(deltaTime);
                    });
                });
            });
        },
        /** Returns current state of the model */
        getCurrentState: getCurrentState,
        /** Set pause state of the model */
        setPause: function (isPaused) {
            isAnimationPaused = isPaused;
            meshControllers.forEach(function (bodyPart) {
                return bodyPart.forEach(function (subModel) { return subModel.forEach(function (controller) { return controller.setPause(isAnimationPaused); }); });
            });
            return getCurrentState();
        },
        /**
         * Sets playback rate (animation speed)
         * @param rate
         */
        setPlaybackRate: function (rate) {
            playbackRate = rate;
            meshControllers.forEach(function (bodyPart) {
                return bodyPart.forEach(function (subModel) { return subModel.forEach(function (controller) { return controller.setPlaybackRate(playbackRate); }); });
            });
            return getCurrentState();
        },
        /**
         * Sets animation to play
         * @param sequenceIndex
         */
        setAnimation: function (sequenceIndex) {
            activeSequenceIndex = sequenceIndex;
            meshControllers.forEach(function (bodyPart) {
                return bodyPart.forEach(function (subModel) { return subModel.forEach(function (controller) { return controller.setAnimation(sequenceIndex); }); });
            });
            return getCurrentState();
        },
        /**
         * Shows specified sub model
         */
        showSubModel: function (bodyPartIndex, subModelIndex) {
            showedSubModels[bodyPartIndex] = subModelIndex;
            meshControllers[bodyPartIndex].forEach(function (subModel, i) {
                var isVisible = i === subModelIndex;
                subModel.forEach(function (controller) {
                    controller.setVisibility(isVisible);
                });
            });
            return getCurrentState();
        },
        /**
         * Sets specific frame of the running animations
         */
        setFrame: function (frame) {
            var _a = modelData.sequences[activeSequenceIndex], numFrames = _a.numFrames, fps = _a.fps;
            var safeFrame = R.clamp(0, numFrames, frame);
            var duration = numFrames / fps;
            var specifiedTime = (duration / numFrames) * safeFrame;
            meshControllers.forEach(function (bodyPart) {
                return bodyPart.forEach(function (subModel) { return subModel.forEach(function (controller) { return controller.setTime(specifiedTime); }); });
            });
            return getCurrentState();
        }
    };
    return modelController;
};
exports.createModelController = createModelController;
